export const DEFAULT_TIMEOUT = 30000;
export const DEFAULT_PING_INTERVAL = 3000;
export const DEFAULT_NOTIFICATIONS_PING_INTERVAL = 10000;
export const DEFAULT_PING_TIMEOUT = 5000;
export const DEFAULT_ACK_TIMEOUT = 5000;
export const LISTEN_STOCK_FROM_STOCKIDS_TIMEOUT = 5000;
export const LISTEN_STOCK_FROM_STOCKIDS_TIMEOUT_PRICING = 5000;

export const DEFAULT_RECONNECT_INTERVAL = 1000;
export const DEFAULT_RECONNECT_DELAY = 1000;
export const DEBOUNCE_ON_INPUT = 1000;
export const DEFAULT_RECONNECT_ATTEMPTS = 5;
export const SEARCH_RESULTS_LIMIT = 40;

export const MAX_RECONNECT_ATTEMPTS = 10;
export const RECONNECT_DELAY = 2000;
export const SOCKET_CONTENT_UPDATE_INTERVAL = 500;
export const PING_STOCK_ID = { stockId: "AAPL_NASDAQ", showTrendChart: false };

//enable logging
export const STOCK_SOCKET_LOGGING_ENABLED = false;
export const PRICE_SOCKET_LOGGING_ENABLED = false;
export const SOCKET_LOGGING_ENABLED = false;
export const NOTIFICATION_SOCKET_LOGGING_ENABLED = false;